import gql from 'graphql-tag';

import { ExternalCollaboratorEntitlementFragment } from './Queries/Fragments/ExternalCollaboratorEntitlementFragment.fragment';

export const GuestBannerSpacePermissionsPortalQuery = gql`
	query GuestBannerSpacePermissionsPortalQuery {
		...ExternalCollaboratorEntitlementFragment
	}

	${ExternalCollaboratorEntitlementFragment}
`;
